import {graphql, useStaticQuery} from "gatsby";

/**
 * Hook to return all available entities.
 *
 * Extend the configured fields as needed.
 *
 * @returns {Entity[]} - An array of entities.
 */
export const useAllEntities = () => {
  const { allStrapiEntities: { nodes } } = useStaticQuery(graphql`
    query {
      allStrapiEntities {
        nodes {
          id
          strapiId
          Roles
          Relations
          identifier
          title
          locale
          smallImage {
            localFile {
                childImageSharp {
                    gatsbyImageData(width: 900)
                }
            }
          }
          largeImage {
            localFile {
                childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                }
            }
          }
          strapiChildren {
            id
            strapiId
            identifier
            locale
            title
            Roles
          }
        }
      }
    }
    `);
  return nodes
}
